export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'character-guide',
    name: '角色图鉴',
    description: '深入解析「邪娠娼馆」中所有核心角色的身世背景、性格特征、命运轨迹与人物关系网络。',
    icon: 'ri-user-star-line',
    articleCount: 12,
  },
  {
    slug: 'story-analysis',
    name: '剧情解析',
    description: '逐章剖析剧情发展脉络，解读关键转折点，揭示隐藏在文字之下的深层叙事结构与象征意义。',
    icon: 'ri-book-open-line',
    articleCount: 8,
  },
  {
    slug: 'world-setting',
    name: '设定考据',
    description: '系统梳理世界观架构，从地理环境、社会制度到魔法体系，全面还原这个暗黑奇幻世界的运行逻辑。',
    icon: 'ri-global-line',
    articleCount: 10,
  },
  {
    slug: 'creation-insight',
    name: '创作解析',
    description: '从文学批评与创作技法角度，分析作品的叙事策略、意象运用与暗黑美学的构建方式。',
    icon: 'ri-quill-pen-line',
    articleCount: 6,
  },
  {
    slug: 'reader-discussion',
    name: '读者讨论',
    description: '汇集读者群体的深度讨论、理论推测与同人创作，展现作品在读者社群中激发的思想碰撞。',
    icon: 'ri-chat-3-line',
    articleCount: 15,
  },
  {
    slug: 'timeline-lore',
    name: '年表编年',
    description: '按时间线梳理世界观中的重要历史事件，构建完整的时间框架，理解各个时代的因果关联。',
    icon: 'ri-timeline-view',
    articleCount: 4,
  },
];